import Skeleton from './Skeleton';

type DetailsSkeletonSection = {
  id: string;
  fieldCount: number;
  columnClassName?: string;
};

type DetailsSkeletonProps = {
  fieldCount?: number;
  columnClassName?: string;
  sections?: DetailsSkeletonSection[];
};

const DetailsSkeleton = ({ fieldCount = 6, columnClassName = 'col-12 col-md-4', sections }: DetailsSkeletonProps) => {
  const detailSections = sections ?? [{ id: 'details', fieldCount, columnClassName }];

  return (
    <div aria-busy="true" className="d-flex flex-column gap-8">
      <output className="visually-hidden">Carregando detalhes...</output>
      {detailSections.map((section) => {
        const fieldIds = Array.from({ length: section.fieldCount }, (_, fieldIndex) => `field-${fieldIndex + 1}`);
        const fieldColumnClassName = section.columnClassName ?? columnClassName;

        return (
          <div key={section.id}>
            {sections ? <Skeleton className="d-block mb-4" height={20} width="30%" /> : null}
            <div className="row g-4">
              {fieldIds.map((fieldId) => (
                <div key={fieldId} className={fieldColumnClassName}>
                  <Skeleton className="d-block mb-2" height={14} width="45%" />
                  <Skeleton className="d-block" height={20} width="80%" />
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DetailsSkeleton;
